import React, { useState, useEffect } from 'react';
import { Icon, IconBlock } from 'anf-core-react';

export default function UrgencyMessage({
  showUrgencyMessage, urgencyMessage, rerenderKey,
}) {
  const [shouldRender, setShouldRender] = useState(showUrgencyMessage);
  const [animationState, setAnimationState] = useState('');

  useEffect(() => {
    let timeoutId;
    if (showUrgencyMessage) {
      setShouldRender(true);
      setAnimationState('fadein show');
    } else if (shouldRender) {
      setAnimationState('fadeout');
      timeoutId = setTimeout(() => {
        setShouldRender(false);
      }, 450); // Duration should match the fadeout animation duration
    }
    return () => clearTimeout(timeoutId);
  }, [showUrgencyMessage, shouldRender]);

  if (!shouldRender) {
    return null;
  }

  return (
    <div className={`urgencyMessage ${animationState}`}>
      <IconBlock icon={<Icon icon="clock" size="s" />}>
        <div
          key={rerenderKey}
          className={`h3 ${showUrgencyMessage ? 'bump' : ''}`}
        >
          {showUrgencyMessage ? urgencyMessage : ''}
        </div>
      </IconBlock>
    </div>
  );
}
